/* Keep the official Spoks form and submission behavior; style only embedded VIP forms. */
(() => {
 const css = `
 :host{font-family:Raleway,Arial,sans-serif}
 [style*="--looks-colors-surface"]{--looks-colors-surface:transparent!important;--looks-colors-on-surface:#f4eee3!important;--input-text-color:#f4eee3!important;--input-border-color:#b29257!important;--input-focus-border-color:#e5bf7f!important;--input-invalid-color:#ffb4a9!important;--btn-text-color:#17130c!important;--btn-bg-color:#d9b16c!important;--looks-colors-primary:#d9b16c!important}
 [style="padding: 32px 0px;"]{padding:0!important}
 .py-8.px-7{padding:0!important}
 h3[slot="title"],h3[slot="title"] + div{display:none}
 .pt-6{padding-top:0!important}
 form{max-width:100%!important;gap:12px}
 form input[type="email"]{min-height:46px;font-size:16px}
 form button[type="submit"]{min-height:44px;background:linear-gradient(100deg,#d6ad6c,#f1d39c 48%,#c99c5b);cursor:pointer}
 form .pt-4{padding-top:0}
 form button:focus-visible,form input:focus-visible{outline:2px solid #f1d39c!important;outline-offset:3px}
 `;
 const apply=()=>document.querySelectorAll('.alpha-spoks-form [data-spoks-form-id],.newsletter [data-spoks-form-id]').forEach(el=>{
  const root=el.firstElementChild?.shadowRoot;
  if(root&&!root.querySelector('[data-alpha-vip-style]')){const style=document.createElement('style');style.dataset.alphaVipStyle='';style.textContent=css;root.append(style);}
 });
 apply();const timer=setInterval(apply,500);setTimeout(()=>clearInterval(timer),30000);
 document.addEventListener('shopify:section:load',apply);
})();